import { UserResources } from '@leroy-merlin-br/backpack-services'

export const getMetaTagContent = (name: string, attribute: string) =>
  document.querySelector(`meta[name="${name}"]`)?.getAttribute(attribute)

export type GetInsightsStoredInfoProps = {
  queryID: string
  indexName: string
  position: number
  objectID: string
}
export const getInsightsStoredInfo = () =>
  JSON.parse(
    localStorage.getItem('__algoliaInsights__') ?? 'null'
  ) as GetInsightsStoredInfoProps | null

export const setInsightsInfo = (hitObj: GetInsightsStoredInfoProps) =>
  localStorage.setItem('__algoliaInsights__', JSON.stringify(hitObj))

export const getAlgoliaToken = (resources: UserResources) => {
  const { id, email } = resources
  const isLogged = email !== ''

  const userToken = id

  if (isLogged) {
    return {
      userToken: userToken
    }
  }
  return {
    useCookie: true
  }
}
